import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AdminLayout from '../../components/admin/AdminLayout';
import RestaurantFormModal from '../../components/admin/RestaurantFormModal';
import { apiRequest } from '../../utils/api';

const RestaurantsPage = () => {
    const { organizationId } = useParams();
    const navigate = useNavigate();
    const [restaurants, setRestaurants] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [editingRestaurant, setEditingRestaurant] = useState(null);

    useEffect(() => {
        loadRestaurants();
    }, [organizationId]);

    const loadRestaurants = async () => {
        setLoading(true);
        try {
            const response = await apiRequest(`/organizations/${organizationId}/restaurants`);
            setRestaurants(response.data || []);
        } catch (error) {
            console.error('Load restaurants error:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (!confirm('Bu restoranı silmek istediğinize emin misiniz?')) {
            return;
        }

        try {
            await apiRequest(`/organizations/${organizationId}/restaurants/${id}`, {
                method: 'DELETE'
            });
            loadRestaurants();
        } catch (error) {
            alert('Restoran silinirken bir hata oluştu');
        }
    };

    return (
        <AdminLayout>
            <div>
                <div className="flex items-center justify-between mb-8">
                    <h1 className="text-3xl font-bold text-gray-900">Restoranlar</h1>
                    <button
                        onClick={() => {
                            setEditingRestaurant(null);
                            setShowModal(true);
                        }}
                        className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
                    >
                        + Yeni Restoran
                    </button>
                </div>

                {loading ? (
                    <div className="flex items-center justify-center py-12">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
                    </div>
                ) : restaurants.length === 0 ? (
                    <div className="text-center py-12 bg-white rounded-lg shadow">
                        <p className="text-gray-500 mb-4">Henüz restoran eklenmemiş.</p>
                        <button
                            onClick={() => setShowModal(true)}
                            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                        >
                            İlk Restoranı Ekle
                        </button>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {restaurants.map((restaurant) => (
                            <div key={restaurant.id} className="bg-white rounded-lg shadow p-6 hover:shadow-lg transition">
                                {restaurant.logo && (
                                    <img
                                        src={restaurant.logo}
                                        alt={restaurant.name}
                                        className="w-full h-48 object-cover rounded-lg mb-4"
                                    />
                                )}
                                <h3 className="text-xl font-bold text-gray-900 mb-2">{restaurant.name}</h3>
                                {restaurant.description && (
                                    <p className="text-sm text-gray-600 mb-4 line-clamp-2">{restaurant.description}</p>
                                )}
                                <div className="flex items-center space-x-2 mb-4">
                                    <span className={`px-2 py-1 rounded text-xs ${
                                        restaurant.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
                                    }`}>
                                        {restaurant.status === 'active' ? 'Aktif' : 'Pasif'}
                                    </span>
                                </div>
                                <div className="flex space-x-2">
                                    <button
                                        onClick={() => {
                                            setEditingRestaurant(restaurant);
                                            setShowModal(true);
                                        }}
                                        className="flex-1 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
                                    >
                                        Düzenle
                                    </button>
                                    <button
                                        onClick={() => handleDelete(restaurant.id)}
                                        className="flex-1 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition"
                                    >
                                        Sil
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {/* Restaurant Form Modal */}
                <RestaurantFormModal
                    isOpen={showModal}
                    onClose={() => {
                        setShowModal(false);
                        setEditingRestaurant(null);
                    }}
                    restaurant={editingRestaurant}
                    organizationId={organizationId}
                    onSuccess={loadRestaurants}
                />
            </div>
        </AdminLayout>
    );
};

export default RestaurantsPage;

